export default "__VITE_PUBLIC_ASSET__cd28d2a8__"